/* eslint-disable max-len */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * View Details Icon
 *
 * @file ViewDetailsIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import PropType from 'prop-types';

const ViewDetailsIcon = ({ className }) => (
  <SvgIcon className={className} xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.55512 0.888794H9.29804C9.53379 0.888794 9.75988 0.982444 9.92658 1.14914L12.9614 4.184C13.1281 4.3507 13.2218 4.57679 13.2218 4.81254V13.3332C13.2218 14.3151 12.4258 15.111 11.444 15.111H2.55512C1.57328 15.111 0.777344 14.3151 0.777344 13.3332V2.66657C0.777344 1.68473 1.57328 0.888794 2.55512 0.888794ZM11.6662 5.33324H9.66623C9.17531 5.33324 8.77734 4.93527 8.77734 4.44435V2.44435H2.55512C2.43239 2.44435 2.3329 2.54384 2.3329 2.66657V13.3332C2.3329 13.456 2.43239 13.5555 2.55512 13.5555H11.444C11.5667 13.5555 11.6662 13.456 11.6662 13.3332V5.33324Z" fill="currentColor" />
  </SvgIcon>
);

ViewDetailsIcon.propTypes = {
  className: PropType.string.isRequired
};

export default ViewDetailsIcon;

